import styled, { css } from "styled-components";
import { animated } from "@react-spring/web";
import { breakpoints } from "@tvg/design-system";
import { PayoutValuesContainerProps } from "../../type";

export const RunnerResultContainer = styled(animated.div)`
  border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  display: flex;
  padding: 0 ${({ theme }) => theme.space["space-4"]} 11px
    ${({ theme }) => theme.space["space-4"]};

  @media screen and ${breakpoints.tablet.max.sm} {
    padding-left: 0;
  }
`;

export const SaddleContainer = styled.div<{ hasPadding?: boolean }>`
  display: flex;

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: ${({ hasPadding, theme }) =>
      hasPadding && `${theme.space["space-3"]} 0 0 0`};
  }
`;

export const PayoutContainer = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.space["space-3"]};
  margin-top: ${({ theme }) => theme.space["space-4"]};
`;

export const HorseInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-left: ${({ theme }) => theme.space["space-4"]};

  @media screen and ${breakpoints.tablet.max.sm} {
    width: 90%;
    margin-left: 10px;
    padding-right: ${({ theme }) => theme.space["space-4"]};
  }
`;

export const PayoutValuesContainer = styled.div<
  Pick<PayoutValuesContainerProps, "numberOfColumns">
>`
  display: grid;
  grid-template-columns: repeat(
    ${({ numberOfColumns }) => numberOfColumns},
    80px
  );
`;

export const PositionContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export const DNF = styled.div`
  width: 30px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2px;
  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.colorTokens.content.subtle};
  color: ${({ theme }) => theme.colorTokens.content.subtle};
  font-size: ${({ theme }) => theme.fontSizes.xs};
`;

export const JockeyTrainerContainer = styled.div<{ isScratched?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  ${({ isScratched }) =>
    isScratched &&
    css`
      opacity: 0.4;
      text-decoration: line-through;
    `}

  @media screen and ${breakpoints.tablet.max.sm} {
    gap: 2px;
    flex-wrap: nowrap;
    width: 100%;
    margin-top: ${({ theme }) => theme.space["space-1"]};
  }
`;

export const Entry = styled.span<{ hideEllipsis?: boolean }>`
  display: flex;
  color: ${({ theme }) => theme.colorTokens.content.subtle};
  margin: 2px 0;
  white-space: nowrap;

  /* Divider to show only on desktop */
  @media screen and ${breakpoints.tablet.min.sm} {
    &:not(:last-child) {
      border-right: 1px solid
        ${({ theme }) => theme.colorTokens.content.subtle3};
      margin-right: 4px;
      padding-right: 4px;
    }
  }

  ${({ hideEllipsis }) =>
    !hideEllipsis &&
    css`
      @media screen and ${breakpoints.tablet.max.sm} {
        text-overflow: ellipsis;
        overflow: hidden;
        display: block;
        width: 100%;
      }
    `}
`;
